import React from 'react';

import useTranslation from '../../../../features/locale/useTranslation';
import { Text } from '../../../Typography';
import { useSelectRootContext } from '../root/SelectRootContext';

import { useSelectPlaceholderVisible } from './useSelectPlaceholderVisible';

import styles from './SelectPlaceholder.module.scss';

type SelectPlaceholderProps = {
    children?: React.ReactNode;
};

export const SelectPlaceholder = ({ children }: SelectPlaceholderProps) => {
    const { t } = useTranslation();
    const { value, readOnly } = useSelectRootContext();
    const placeholder = readOnly && value === null ? t('None') : (children ?? t('Select...'));

    const shouldShow = useSelectPlaceholderVisible();

    if (!shouldShow) return null;

    if (typeof placeholder !== 'string') {
        return placeholder;
    }

    return (
        <div className={styles.container}>
            <Text truncate className={styles.placeholder}>
                {placeholder}
            </Text>
        </div>
    );
};
